import AuthMixin from '@/components/mixins/auth-mixin'

export default {
  name: 'defaultLayoutStructurePage',
  components: {
  },
  props: {
    dataProp: {
      type: Object,
      default () { return {} }
    }
  },
  watch: {
    dataProp (val) {
      this.dataPropVal = val
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      title: 'default-layout-structure-page',
      dataPropVal: this.dataProp
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('default-layout-change', { action, payload: { data } })
      }
    }
  },
  mounted () {}
}
